import { ProjectModel } from 'model/ProjectModel'
import {
  AssemblyDto,
  RowDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { BomItemPointer } from '../../../../model/Project/BomItemPointer'
import { bomItemSelector } from './bomItemSelector'

export const bomItemExportedToErpSelector =
  (bomItemPointer: BomItemPointer) => (state: RootAppState) => {
    let bomItem: ProjectModel | AssemblyDto | RowDto

    if (!bomItemPointer) return null
    if (bomItemPointer.id === state.project?.activeProject?.id) {
      bomItem = state.project.activeProject
    } else {
      bomItem = bomItemSelector(state, bomItemPointer)
    }

    return {
      isExported: bomItem?.isExportedToErp,
      exportedResult: bomItem?.exportedToErpResult,
      // TODO: check why the backend is not sending this property for the project
      exportedStatus: bomItem?.['exportedToErpStatus'] ?? 'NotApplicable',
    }
  }
